import { render } from "./Adminusers.vue?vue&type=template&id=a3cd4524"
import script from "./Adminusers.vue?vue&type=script&lang=js"
export * from "./Adminusers.vue?vue&type=script&lang=js"

import exportComponent from "/home/treim/code/casp/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__